import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
 
import { Button } from 'primereact/button';

import { forgotPassword } from '@actions/auth';



import './style.scss'

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { history, t } = this.props
    return (
      <section className="loginContSuccess is-full-height p-d-flex p-jc-center p-ai-center">
        <div className="conteiner">
          <div className="p-grid">
            <div className="p-col-12 card p-p-6">
              <div className="p-grid containerForm">
                <div onSubmit={this.onSubmit} className="p-col p-fluid p-pt-5">
                  <div className="p-text-center">
                    <img src="/assets/img/check.png" width="43" height="43" alt="Programa integridad y cumplimiento Compromiso de todos" />
                  </div>
                  <h2 className="p-mb-6 p-text-center p-mt-5"> {t("Nueva Contraseña Configurada con Éxito")} </h2>
                  <p className="p-mb-6 p-text-center"> {t("La contraseña se ha modificado y ahora podrás iniciar sesión con ella de ahora en adelante.")} </p>
                  <Button
                    type="button"
                    label={t("Ir al Dashboard")}
                    onClick={() => history.push("/dashboard")}
                    className="p-button p-mt-3"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapDispatchToProps = {
  forgotPassword
};

export default compose(
  withTranslation(),
  connect(null, mapDispatchToProps)
)(ForgotPassword);
